<template>
  <div>
    <span v-if="chosenAddress">已选择地址：{{ chosenAddress }}</span>
    <el-button type="primary" size="mini" @click="showMap = true">选择地址</el-button>
    <el-dialog title="选择地址" :visible.sync="showMap">
      <div class="search">
        <el-autocomplete placeholder="请输入关键字" v-model="keywords" @select="chooseAddress" :trigger-on-focus="false"
                         :fetch-suggestions="autoComplete" clearable style="width: 100%;"/>
      </div>
      <div style="height: 400px;width: 100%">
        <amap :zoom="15" :center.sync="showAddress.position">
          <amap-marker  :position.sync="showAddress.position"/>
        </amap>
      </div>
      <div slot="footer">
        <el-button @click="showMap = false">取 消</el-button>
        <el-button type="primary" @click="confirmChoose">确 定</el-button>
      </div>
    </el-dialog>
  </div>

</template>

<script>
export default {

  props: {
    address: {
      type: Object,
      default: function () {
        return {
          position: null,
          name: "",
          address: ""
        }
      }
    }
  },
  data() {
    return {
      showMap: false,
      keywords: "",
      chosenAddress: "",
      showAddress: {
        name: "",
        address: ""
      }
    };
  },
  methods: {
    autoComplete: function (keywords, cb) {
      let ac = new AMap.AutoComplete();
      if (!keywords) {
        this.tips = [];
      } else {
        ac.search(keywords, (status, result) => {
          result.tips.forEach(row => {
            row.value = row.name + "(" + row.district + row.address + ")";
          })
          cb(result.tips)
        });
      }
    },
    chooseAddress: function (poi) {
      const pos = [poi.location.lng, poi.location.lat];
      this.showAddress = {
        position: pos,
        name: poi.name,
        address: poi.district + poi.address
      };
    },
    confirmChoose: function () {
      this.showMap = false;
      this.chosenAddress = this.keywords;
      this.$emit('confirm', this.showAddress)
    },
    initValue: function () {
      this.showAddress = this.address;
      this.keywords = this.showAddress.name;
      if (this.showAddress.address) {
        this.keywords += "(" + this.showAddress.address + ")"
      }
      this.chosenAddress = this.keywords;
    }
  },
  created: function () {
    this.initValue();
  },
  watch: {
    address: function () {
      this.initValue();
    }
  }
}
</script>

<style scoped>
.search {
  padding-bottom: 10px;
}
</style>



// WEBPACK FOOTER //
// src/components/i-map.vue